const categoryGA = 'headerMenu';

export const NAVIGATION_TRACKING_LOGO_BUTTON = {
  actionGA: 'header_logo',
  categoryGA,
  labelGA: null, // to override any value coming from previous tracking
};

export const NAVIGATION_TRACKING_CONTACT_BUTTON = {
  actionGA: 'header_contact',
  categoryGA,
  labelGA: 'clickToCall',
};

export const getNavigationCallCenterButtonTrackingData = (label) => ({
  actionGA: 'header_contact',
  categoryGA,
  labelGA: label,
});

export const getNavigationLanguagesButtonTrackingData = (label) => ({
  actionGA: 'header_language',
  categoryGA,
  labelGA: label,
});

export const getNavigationItemLinkTrackingData = (label) => ({
  actionGA: `header_${label}`,
  categoryGA,
  labelGA: label,
});

export const getNavigationSubItemLinkTrackingData = ({ label, parentLabel }) => ({
  actionGA: `header_${parentLabel}`,
  categoryGA,
  labelGA: label,
});
